import Vue from 'vue'
import _debounce from 'lodash.debounce'
import PromiseFileReader from 'promise-file-reader'
import pwd from 'generate-password'

export default {
  namespaced: true,
  state: {
    selectedTab: null,
    selectedTabID: null,
    tabs: [{ label: 'Utilizatori', _id: 'users' }],
    search: null,
    headers: [],
    items: [],
    total: 0,
    pagination: {
      sortBy: 'createdAt',
      descending: true,
      page: 1,
      rowsPerPage: 10
    },
    loading: false,
    restrictedHeaders: ['_id', 'username', 'password', 'email', 'admin', 'avatar', 'createdAt', 'updatedAt', 'activitate'],
    hookHeaders: ['avatar', 'createdAt', 'updatedAt', 'activitate'],
    minIndex: 9,
    unique: {

    },
    relatedItems: {
      cifuri: [],
      rapoarte: [],
      harti: [],
      tip_apl: ['Judet', 'Municipiu', 'Oras', 'Comuna']
    },
    serice: {
      path: 'users'
    }
  },
  getters: {
    tabs: state => state.tabs,
    selectedTab: state => state.selectedTab,
    selectedTabID: state => state.selectedTabID,
    headers: state => state.headers,
    items: state => state.items,
    total: state => state.total,
    loading: state => state.loading,
    restrictedHeaders: state => state.restrictedHeaders,
    hookHeaders: state => state.hookHeaders,
    pagination: state => state.pagination,
    minIndex: state => state.minIndex,
    unique: state => state.unique,
    search: state => state.search,
    relatedItems: state => state.relatedItems
  },
  mutations: {
    clearState (state) {
      // state.tabs = [] // nope, because tabs are not dynamic
      state.items = []
      state.headers = []
    },
    setSelectedTab (state, payload) {
      state.selectedTab = payload
      state.selectedTabID = state.tabs[payload]._id
    },
    setHeaders (state, payload) {
      Vue.set(state, 'headers', payload)
    },
    setItems (state, payload) {
      state.items = payload
    },
    setTotal (state, payload) {
      state.total = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setPagination (state, payload) {
      Vue.set(state, 'pagination', payload)
    },
    setSortBy (state, payload) {
      Vue.set(state.pagination, 'sortBy', payload)
    },
    setUnique (state, payload) {
      const arr = payload.values.map(row => {
        return Object.values(row).join('')
      })
      Vue.set(state.unique, payload.head, arr)
    },
    setSearch (state, payload) {
      state.search = payload
    },
    setRelatedItems (state, payload) {
      Vue.set(state.relatedItems, payload.type, payload.data)
    }
  },
  actions: {
    setEventWatchers ({ commit, dispatch, rootState }) {
      rootState.services.users.events.forEach(event => {
        rootState.services.users.on(event, data => {
          commit('setLoading', true)
          dispatch('fetchHeaders')
          dispatch('fetchItems')
        })
      })
      rootState.services.users.on('batchDeleteSuccess', data => {
        dispatch('fetchItems')
      })
      rootState.services.userheaders.events.forEach(event => {
        rootState.services.userheaders.on(event, data => {
          commit('setLoading', true)
          dispatch('fetchHeaders')
          dispatch('fetchItems')
        })
      })
    },
    fetchTabs () {

    },
    fetchHeaders: _debounce(({ commit, rootState, dispatch }) => {
      commit('setLoading', true)
      rootState.feathers.service('userheaders').find({
        query: {
          $paginate: false,
          $sort: {
            index: 1
          }
        }
      }).then(result => {
        // dispatch('saveMessage', {
        //   user: rootState.auth.user._id,
        //   text: `Citire proprietati "utilizatori" reusita.`,
        //   timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        //   type: 'info'
        // }, { root: true })

        commit('setHeaders', result)
        dispatch('fetchUniques', result)
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare proprietati "utilizatori"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000),
    fetchItems: _debounce(({ state, commit, rootState, dispatch }) => {
      commit('setLoading', true)
      let skip = 0

      if (!state.pagination.sortBy) {
        commit('setSortBy', 'createdAt')
      }

      let query = {}
      if (state.pagination.rowsPerPage === -1) {
        query = {
          $paginate: false
        }
      } else {
        query = {
          $limit: state.pagination.rowsPerPage,
          $skip: state.pagination.rowsPerPage * (state.pagination.page - 1)
        }
      }

      if (state.search && state.search.length) {
        query.$search = state.search
      }

      query.$sort = {
        [state.pagination.sortBy || 'createdAt']: state.pagination.descending ? -1 : 1
      }

      rootState.feathers.service('users').find({ query }).then(result => {
        // dispatch('saveMessage', {
        //   user: rootState.auth.user._id,
        //   text: `Citire "utilizatori" reusita. Pagina: ${state.pagination.page}, Total: ${result.total || result.length || 0}`,
        //   timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        //   type: 'info'
        // }, { root: true })

        if (state.pagination.rowsPerPage === -1) {
          commit('setItems', result)
          commit('setTotal', result.length)
        } else {
          commit('setItems', result.data)
          commit('setTotal', result.total)
        }

        const { page, ...pagination } = state.pagination
        if (page > 1 && skip > result.total) {
          pagination.page = 1
          dispatch('paginationChanged', pagination)
        }
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare "utilizatori"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000),
    fetchUniques ({ commit, rootState, dispatch }, payload) {
      commit('setLoading', true)
      payload.forEach(header => {
        if (header.rules.includes('unique')) {
          rootState.feathers.service('users').find({
            query: {
              $distinct: header.value
            }
          }).then(result => {
            commit('setUnique', { head: header.value, values: result })
          }).catch(err => {
            dispatch('saveMessage', {
              user: rootState.auth.user._id,
              text: `Eroare la interogare valori unice "utilizatori"... Detalii: ${err.message || err.error.message}`,
              timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
              type: 'error'
            }, { root: true })
            commit('setLoading', false)
          }).finally(() => {
            commit('setLoading', false)
          })
        }
      })
    },
    search ({ commit, dispatch }, payload) {
      commit('setSearch', payload)
      dispatch('fetchItems')
    },
    toggleHeadVisibility ({ rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      rootState.services.userheaders.patch(payload.id, {
        visible: payload.visibility
      }).then(result => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Vizibilitatea proprietatii ${result.label} din colectia "utilizatori" a fost schimbata in ${result.visible ? '"vizibil"' : '"ascuns"'}!`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'info'
        }, { root: true })
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la schimbarea vizibilitatii unei proprietati in colectia "utilizatori"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      }).finally(() => {
        commit('setLoading', false)
      })
    },
    addHeader ({ rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      rootState.services.userheaders.create(payload).then(res => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `A fost adaugata proprietatea "${res.label}" in colectia "utilizatori".`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'success'
        }, { root: true })
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la adaugare proprietate in colectia "utilizatori"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      }).finally(() => {
        commit('setLoading', false)
      })
    },
    editHeader ({ rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      const label = payload.values.label
      rootState.services.userheaders.patch(payload.id, payload.values).then(res => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `A fost modificata proprietatea "${res.label}" in colectia "utilizatori".`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'success'
        }, { root: true })
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la modificare proprietate "${label}" in colectia "utilizatori"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      }).finally(() => {
        commit('setLoading', false)
      })
    },
    deleteHeader ({ rootState, commit, dispatch }, payload) {
      if (payload.id) { // make sure there's an ID so we don't delete everything
        commit('setLoading', true)
        rootState.services.userheaders.remove(payload.id).then(res => {
          dispatch('saveMessage', {
            user: rootState.auth.user._id,
            text: `A fost stearsa proprietatea "${res.label}" din colectia "utilizatori".`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'success'
          }, { root: true })
        }).catch(err => {
          dispatch('saveMessage', {
            user: rootState.auth.user._id,
            text: `Eroare la stergerea unei proprietati din colectia "utilizatori"... Detalii: ${err.message || err.error.message}`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'error'
          }, { root: true })
        }).finally(() => {
          commit('setLoading', false)
        })
      }
    },
    addItem ({ rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      rootState.services.users.create(payload).then(res => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `A fost adaugat un element in colectia "utilizatori". Username: "${res.username}"`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'success'
        }, { root: true })
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la adaugare element in colectia "utilizatori"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      }).finally(() => {
        commit('setLoading', false)
      })
    },
    editItems ({ rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      payload.items.forEach(item => {
        const username = item.username
        rootState.services.users.patch(item._id, item).then(res => {
          dispatch('saveMessage', {
            user: rootState.auth.user._id,
            text: `A fost modificat un element in colectia "utilizatori"... Username: "${res.username}"`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'success'
          }, { root: true })
        }).catch(err => {
          dispatch('saveMessage', {
            user: rootState.auth.user._id,
            text: `Eroare la modificare element cu username ${username} in colectia "utilizatori"... Detalii: ${err.message || err.error.message}`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'error'
          }, { root: true })
        }).finally(() => {
          commit('setLoading', false)
        })
      })
    },
    deleteItems ({ rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      // rootState.services['delete-worker']
      //   .remove({ items: payload.ids, service: 'users' })
      //   .finally(() => {
      //     commit('setLoading', false)
      //   })

      rootState.services.users.remove(null, { query: { _id: { '$in': payload.ids } } })
        .then(res => {
          commit('setLoading', false)
        })
    },
    paginationChanged ({ commit, dispatch }, payload) {
      commit('setPagination', payload)
      dispatch('fetchItems')
    },
    setSelectedTab ({ commit }) {
      commit('setSelectedTab', 0)
    },
    importFromFile ({ commit, dispatch, rootState }, payload) {
      return PromiseFileReader.readAsDataURL(payload).then(result => {
        commit('setLoading', true)
        return rootState.services['users-upload'].create({ file: result })
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la citire fisier... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      }).finally(() => {
        commit('setLoading', false)
      })
    },
    acceptImport ({ rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      if (payload.id) {
        rootState.services['users-upload'].remove(payload.id, { query: {
          headers: payload.headers,
          mode: payload.mode
        } }).catch(err => {
          dispatch('saveMessage', {
            user: rootState.auth.user._id,
            text: `Eroare la salvare bulk in colectia "utilizatori"... Detalii: ${err.message || err.error.message}`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'error'
          }, { root: true })
          dispatch('fetchHeaders')
          dispatch('fetchItems')
        }).finally(() => commit('setLoading', false))
      }
    },

    async toggleFavoriteCif ({ dispatch, rootState }, payload) {
      const user = rootState.auth.user
      const freshUser = await rootState.feathers.service('users').get(user._id)

      const favs = freshUser.favs || []

      const isFavIndex = favs.findIndex(f => f.cif_op === payload.cif_op && f.cif_os === payload.cif_os)

      if (isFavIndex > -1) {
        favs.splice(isFavIndex, 1)
      } else {
        favs.push({ cif_op: payload.cif_op, cif_os: payload.cif_os })
      }

      rootState.services.users.patch(user._id, { favs }).then(res => {
        dispatch(`${payload.type}/fetchItems`, null, { root: true })
      })
    },

    fetchAllRelated ({ commit, dispatch, rootState }, search) {
      // search is useless because the autocomplete component handles that
      dispatch('fetchAllCIFs', search)
      dispatch('fetchAllRapoarte', search)
      dispatch('fetchAllHarti', search)
    },
    fetchAllCIFs ({ commit, dispatch, rootState }, search) {
      // console.log('search: ', search)
      const query = {
        $relatedSearch: true,
        $paginate: false,
        $sort: {
          denumire_apl: 1,
          cif_op: 1,
          cif_os: 1
        },
        $select: ['cif_op', 'cif_os', 'denumire_apl']
      }

      const searchFor = search && String(search).length ? String(search).trim() : null

      if (searchFor) {
        query.$regex = searchFor
      }

      rootState.services.cifuri.find({ query }).then(res => {
        commit('setRelatedItems', { type: 'cifuri', data: res })
        // console.log(res)
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la citire cifuri... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      })
    },
    async fetchAllRapoarte ({ commit, dispatch, rootState }, search) {
      // console.log('search: ', search)
      const queryRapoarte = {
        $relatedSearch: true,
        $paginate: false,
        $sort: {
          denumire: 1
        },
        $select: ['_id', 'denumire', 'vizibil', 'public', 'perioade', 'tab']
      }

      const queryPerioade = {
        $paginate: false,
        $select: ['label'],
        $sort: {
          date: -1
        }
      }

      const rapoarte = await rootState.services.rapoarte.find({ query: queryRapoarte })
      const perioade = await rootState.services.cifuriperioade.find({ query: queryPerioade })

      const rapoarteCuPerioade = []

      perioade.forEach(perioada => {
        const parts = perioada.label.split('-')
        rapoarte.forEach(raport => {
          if (raport.perioade.includes(parts[1])) {
            raport.added = true
            rapoarteCuPerioade.push({
              ...raport,
              perioada: perioada.label,
              _idCuPerioada: `${raport._id}_${perioada.label}`,
              an: parts[0],
              trimestru: parts[1]
            })
          }
        })
      })

      rapoarte.forEach(raport => {
        if (!raport.added) {
          rapoarteCuPerioade.push({
            ...raport,
            perioada: 'agregat',
            _idCuPerioada: `${raport._id}_null-null`,
            an: 'agg',
            trimestru: 'agg'
          })
        }
      })

      rapoarteCuPerioade.sort((a, b) => {
        const res = a.tab.localeCompare(b.tab) * -1

        return res || a.perioada.localeCompare(b.perioada)
      })

      commit('setRelatedItems', { type: 'rapoarte', data: rapoarteCuPerioade })
    },
    fetchAllHarti ({ commit, dispatch, rootState }, search) {
      // console.log('search: ', search)
      const query = {
        $paginate: false,
        $sort: {
          denumire: 1
        },
        $select: ['denumire']
      }

      rootState.services.adminmaps.find({ query }).then(res => {
        commit('setRelatedItems', { type: 'harti', data: res })
        // console.log(res)
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la citire harti... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      })
    },

    duplicateUser ({ state, rootState }, payload) {
      const user = state.items.find(item => item._id === payload)

      const newUser = { ...user }

      delete newUser.createdAt
      delete newUser.updatedAt
      delete newUser._id
      delete newUser.__v

      newUser.email += '_(copie)'
      newUser.username += ' (copie)'
      newUser.password = pwd.generate({
        length: 16,
        numbers: true,
        symbols: true,
        uppercase: true,
        exclude: '*()+_-=}{[]|:;"/?.><,`~',
        strict: true
      })

      rootState.services.users.create(newUser)
    }
  }
}
